import { makeStyles } from "@material-ui/core/styles";

export const useBreadcrumbsButtonStyles = makeStyles(() => ({
  breadcrumbsButton: {
    fontSize: "11px",
    height: "16px",
    margin: "0",
    padding: "4px",
  },
}));
